<template>

  <div class="c-select-calendar u-w320">
    <div class="c-select-calendar__selected" @click="showModal">
      <div class="c-icon c-icon--gray-3 u-wh18">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <use xlink:href="/assets/img/sprite.svg#calendar" />
        </svg>
      </div>
      <div class="c-select-calendar__date">{{ startDateString }}</div>
      <div class="c-select-calendar__date">{{ endDateString }}</div>
    </div>
    <input type="hidden" name="analysis_date_from" value="" />
    <input type="hidden" name="analysis_date_to" value="" />
    <div class="c-error c-error--balloon c-error--group-name">
      <div class="c-error__text"></div>
    </div>

    <!-- モーダルウィンドウ -->
    <div
      id="date-range-picker-modal"
      class="c-modal"
      :class="[{'is-active': isActiveCalendarModal}]"
    >
      <div class="c-modal__bg" @click="onCloseClick"></div>
      <div class="c-modal__content c-modal__content--full-width">
        <div class="c-modal__close" @click="onCancelClick">
          <div class="c-icon c-icon--white u-wh14">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#close" />
            </svg>
          </div>
        </div>
        <div class="c-modal__inner">
          <div class="c-calendar">
            <div class="c-calendar__content">
              <div class="c-calendar__datepicker">
                <v-date-picker
                  ref="calendar"
                  v-model.range="range"
                  :columns='3'
                  :masks="masks"
                  :max-date="maxRange.end"
                  :min-date="maxRange.start"
                  locale="ja"
                />
              </div>
            </div>
          </div>
          <div class="c-calendar__foot">
            <div class="c-calendar__btns">
              <button
                :class="[`c-btn c-btn--modal c-btn--gray u-w280 u-h34 u-fs14`]"
                type="button"
                name="cancel"
                value="cancel"
                @click="onCancelClick"
              >
                <p class="c-btn__text">キャンセル</p>
              </button>
              <button
                :class="[`c-btn c-btn--modal c-btn--blue u-w280 u-h34 u-fs14`, {'is-loading': isLoading}]"
                type="button"
                name="delete"
                value="delete"
                :disabled="isLoading"
                @click="onEnterClick"
              >
                <p class="c-btn__text">決定</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /モーダルウィンドウ -->
  </div>
</template>

<script>
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  components: { 'v-date-picker': DatePicker },
  props: {
    initialStartDate: String,
    initialEndDate: String,
    onDateRangeChanged: { type: Function, required: true },
  },
  data: function () {
    return {
      isActiveCalendarModal: false,
      isLoading: false,
      masks: {
        title: 'YYYY年 M月',
        navMonths: 'M月',
      },
      maxRange: {
        start: dayjs().add(-10, 'years').toDate(),
        end: dayjs().toDate(),
      },
      previousRange: {
        start: null,
        end: null,
      },
      range: {
        start: null,
        end: null,
      },
    };
  },

  computed: {
    startDateString: function() {
      return this.range.start
        ? dayjs(this.range.start).format('YYYY/MM/DD')
        : '-';
    },
    endDateString: function() {
      return this.range.end
        ? dayjs(this.range.end).format('YYYY/MM/DD')
        : '-'
    },
  },

  // 親コンポーネントが API 応答などで initialStartDate/initialEndDate を後から
  // 更新するケース（シナリオ配信成果の「最初の配信日〜最終配信日」自動反映など）に
  // 対応するため、props 変化を watch して内部 range を同期する。
  // ここでは onDateRangeChanged を呼ばない: watch 経由で親の状態を再書き換えする
  // 無限ループや、API 自動算出値を「ユーザー手動指定」と誤認させる副作用を避けるため。
  watch: {
    initialStartDate: function() { this.syncRangeFromProps(); },
    initialEndDate:   function() { this.syncRangeFromProps(); },
  },
  mounted: function() {
    // 引数で指定された初期化用日付に正当性がある場合は、日付範囲変数に設定
    this.syncRangeFromProps();

    // 設定した日付でデータ更新関数を実行
    this.onDateRangeChanged(this.range);
  },

  methods: {
    // initialStartDate / initialEndDate を内部 range に反映する.
    // mounted 初期化と props 更新 watch の双方から呼び出す共通ヘルパー.
    syncRangeFromProps: function() {
      this.range = {
        start: dayjs(this.initialStartDate).isValid()
          ? dayjs(this.initialStartDate).toDate()
          : null,
        end: dayjs(this.initialEndDate).isValid()
          ? dayjs(this.initialEndDate).toDate()
          : null,
      };
    },
    showModal: function() {
      this.previousRange = this.range;
      this.isActiveCalendarModal = true;
      // v-calendar は初回描画時に値が無いと min-date（10 年前）の月を表示し、
      // 後から値が入っても表示月を動かさない。開くたびに選択中の終了日（無ければ今日）を右端の月に合わせる.
      this.$refs.calendar.move(this.range.end || new Date(), { position: -1 });
    },
    onCloseClick: function() {
      this.range = this.previousRange;
      this.isActiveCalendarModal = false;
    },
    onCancelClick: function() {
      this.range = this.previousRange;
      this.isActiveCalendarModal = false;
    },
    onEnterClick: function() {
      this.isActiveCalendarModal = false;
      this.onDateRangeChanged(this.range);
    },
  },
};
</script>
